module.exports = __webpack_public_path__ + "img/SEMINAR_WINTER_2027.4e3b1e76.jpg";